<div class="p-4" *transloco="let t; read 'home.calculator'">
  <div class="mb-4 {{textColorClass}} font-bold">
    {{ t('azimuth.title') }}
  </div>
  <div [style.transform]="'rotate('+orientation+'deg)'">
    <div class="long-arrow-right {{pointerColorClasses}}"></div>
  </div>
</div>
